import api, { ValidateAxiosError, ValidateAxiosErrorSemRedirecionar } from '@/modules/api.service';
import { clearAuthSession } from '@/modules/system/auth/application/auth-session.utils';
import { Endpoints } from '@/shared/constants/endpoints';
import { ReadUsuarioDto } from '@/api.types';
import { FindUsuarioDto } from '@/api.types.extra';
import { isAxiosError } from 'axios';

export async function GetUsuarios(parameters: FindUsuarioDto) {
  if (parameters) {
    parameters.skip ??= 0;
    parameters.take ??= 10;
  }

  try {
    const response = await api.get<[ReadUsuarioDto[], number]>(Endpoints.USUARIO, { params: parameters });
    return response.data;
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao buscar usuário(s).');
  }
}

export async function GetUsuarioBy(username: string) {
  return api
    .get<ReadUsuarioDto>(Endpoints.USUARIOBY + '/' + username)
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      return ValidateAxiosError<ReadUsuarioDto>(error, 'Falha ao bucar o usuário.');
    });
}

/**
 * Lista de permissões do usuário
 * @param {string} username
 * @returns Usuario ou null.
 */
export async function GetRolesFromUserName(username: string) {
  return api
    .get<string>(Endpoints.AUTH + '/roles/' + username)
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      return ValidateAxiosError<string>(error, 'Falha ao bucar permissões.');
    });
}

export type AuthMeResponse = {
  userId: number;
  pessoaId?: string;
  username?: string;
  nome?: string;
  cpf?: string;
  corfundotabela?: string;
  corletratabela?: string;
  visao: number;
  loginSenhaHabilitado: boolean;
  ehDefensorDiretor: boolean;
  permissoes: { role: number; level: number }[];
};

export async function GetAuthMe() {
  try {
    const res = await api.get<AuthMeResponse>(Endpoints.AUTH + '/me');
    return res.data;
  } catch (error) {
    if (isAxiosError(error) && error.response?.status === 401) {
      clearAuthSession();
    }
    return ValidateAxiosErrorSemRedirecionar<AuthMeResponse>(
      error,
      'Falha ao carregar sessão.',
    );
  }
}